import { Navbar } from "../../components/navbar"
import logoT from "../../assets/logo/logo-t-2.png"
import imgBanner from "../../assets/projects/ateliersza/ateliers_5.png"
import { homeWorkData } from "../../json/HomeWorkData"
import { Footer } from "../../components/footer";
import { Collab } from "../../components/collab";
import img1 from "../../assets/projects/ateliersza/ateliers_1.png"
import img2 from "../../assets/projects/ateliersza/ateliers_6.png"

export const AteliersZA = () => {
    const findProjectByTitle = (title) => (
        homeWorkData.find(project => project.title === title)
    )

    const project = findProjectByTitle("Ateliers Z+A")
    // console.log(project);

    return (
        <>
            <Navbar />
            <section className="px-[16px] md:px-[32px] lg:px-[192px] bg-[#C0D8D7] pb-[4rem] font-jakarta">
                <div className="flex items-center gap-3 pt-[2.2rem]">
                    <img src={logoT} alt="" className="h-[2rem] object-cover" />
                    <span className="text-[#272727] font-spaceGrotesk text-[18px] font-normal mt-[5px]">thoby.za</span>
                </div>
                <div className="flex flex-col mt-[4rem] md:mt-[5rem] gap-[0.5rem] md:gap-[1rem]">
                    <span className="text-[#002921] text-[17px] font-medium  opacity-[0.8]">Selected Work</span>
                    <h1 className="text-[3.5rem] md:text-[5rem] font-medium text-[#002921] tracking-tight leading-none">{project.title}</h1>
                    {/* <span className="mt-[4px] text-[#002921] underline underline-offset-[0.5rem] font-medium text-[1.1rem] opacity-[0.9]">Web Development</span> */}
                </div>
            </section>
            <section className="px-[8px] md:px-[32px] lg:px-[192px] bg-[#C0D8D7] rounded-b-2xl pb-[10px] md:pb-[32px]">
                <img src={imgBanner} alt="" className="rounded-2xl w-full object-cover" />
            </section>
            {/* Desc */}
            <section className="px-[16px] md:px-[32px] lg:px-[192px] pt-[2.75rem] pb-[2.5rem] md:pt-[5rem] md:pb-[4rem] bg-[#FCFCFC] font-jakarta">
                <div className="flex flex-col md:flex-row justify-between gap-[2rem] md:gap-[3rem]">
                    <div className="flex flex-col gap-[1.25rem] md:gap-[1.75rem]">
                        <div className="flex flex-col gap-[0.15rem]">
                            <span className="text-[#798F8B] text-[14.5px] md:text-[15px] leading-[1.5rem]">Product</span>
                            <h4 className="text-[22.5px] md:text-[25px] text-[#002921] font-medium opacity-[0.9]">{project.title}</h4>
                        </div>
                        <div className="flex flex-col gap-[0.15rem]">
                            <span className="text-[#798F8B] text-[14.5px] md:text-[15px] leading-[1.5rem]">Role</span>
                            {project.role.map((item, index) => (
                                <h4 key={index} className="text-[22.5px] md:text-[25px] text-[#002921] font-medium opacity-[0.9]">{item}</h4>
                            ))}
                        </div>
                        <div className="flex flex-col gap-[0.15rem]">
                            <span className="text-[#798F8B] text-[14.5px] md:text-[15px] leading-[1.5rem]">Year</span>
                            <h4 className="text-[22.5px] md:text-[25px] text-[#002921] font-medium opacity-[0.9]">{project.year}</h4>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[2.5rem] md:gap-[3rem]">
                        <div className="flex flex-col gap-[1.75rem] md:gap-[2.5rem] pt-[2rem] md:mt-[5rem] md:max-w-[45vw] border-t border-gray-200 md:border-t-0">
                            <div className="flex flex-col gap-[0.4rem]">
                                <span className="text-[#798F8B] text-[14.5px] md:text-[15px]">Description</span>
                                <p className="text-[18px] md:text-[20px] text-[#002921] font-medium opacity-[0.9]">
                                    {project.descDetail}
                                </p>
                            </div>
                            {project?.team && (
                                <div className="flex flex-col gap-[0.4rem]">
                                    <span className="text-[#798F8B] text-[14.5px] md:text-[15px]">Team</span>
                                    <h4 className="text-[18px] md:text-[20px] text-[#002921] font-medium whitespace-pre opacity-[0.9]">{project.team}</h4>
                                </div>
                            )}
                            <div className="flex flex-col gap-[0.4rem]">
                                <span className="text-[#798F8B] text-[14.5px] md:text-[15px]">Tech Stack</span>
                                <h4 className="text-[18px] md:text-[20px] text-[#002921] font-medium whitespace-pre-wrap opacity-[0.9]">{project.techStack}</h4>
                            </div>
                        </div>
                        {/* button */}
                        <div className="flex items-center gap-[0.75rem]">
                            <a
                                href={project.webLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                id="button-animation"
                                className="flex items-center group gap-[0.4rem] w-max rounded-full border border-gray-400 md:text-[16px] text-[#828997] py-[0.6rem] px-[1.2rem]"
                            >
                                <span className="font-medium">Launch Project</span>
                                <svg
                                    viewBox="0 0 26 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-[1rem] w-[1rem] mt-[3px] stroke-[#828997] group-hover:stroke-[#002921]"
                                >
                                    <path
                                        d="M10.3291 5.68945H20.6694C20.727 5.68945 20.7738 5.73622 20.7738 5.7939V16.1342"
                                        stroke-width="2.08894"
                                        stroke-miterlimit="10"
                                    ></path>
                                    <path
                                        d="M20.7744 5.68945L7.19629 19.2676"
                                        stroke-width="2.08894"
                                        stroke-miterlimit="10"
                                    ></path>
                                </svg>
                            </a>
                            {/*  */}
                            <a
                                href={project.githubLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                id="button-animation"
                                className="flex items-center group gap-[0.4rem] w-max rounded-full border border-gray-400 text-[16px] text-[#828997] py-[0.6rem] px-[1.2rem]"
                            >
                                <span className="font-medium">GitHub</span>
                                <svg
                                    viewBox="0 0 26 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-[1rem] w-[1rem] mt-[3px] stroke-[#828997] group-hover:stroke-[#002921]"
                                >
                                    <path
                                        d="M10.3291 5.68945H20.6694C20.727 5.68945 20.7738 5.73622 20.7738 5.7939V16.1342"
                                        stroke-width="2.08894"
                                        stroke-miterlimit="10"
                                    ></path>
                                    <path
                                        d="M20.7744 5.68945L7.19629 19.2676"
                                        stroke-width="2.08894"
                                        stroke-miterlimit="10"
                                    ></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            {/* Images */}
            <section className="px-[16px] md:px-[32px] lg:px-[192px] bg-[#FCFCFC] pt-[1.5rem] pb-[8rem] md:pb-[9rem] flex flex-col gap-[0.75rem] md:gap-[1.25rem]">
                <img src={img1} alt="" className="rounded-lg w-full" />
                <img src={img2} alt="" className="rounded-lg w-full" />
            </section>
            <Collab />
            <Footer />
        </>
    )
}